import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../data/menu";

export const WhatsAppFab = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab-button"
      aria-label="Pedir por WhatsApp"
      className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-50 inline-flex items-center gap-2.5 bg-[#25D366] text-white px-4 sm:px-5 py-3 sm:py-3.5 rounded-full shadow-xl shadow-[#25D366]/30 hover:bg-[#1EBE5D] hover:scale-105 transition-all duration-300"
    >
      <MessageCircle size={20} strokeWidth={2} className="fill-white" />
      <span className="hidden sm:inline font-sans text-sm font-medium">
        Pedir por WhatsApp
      </span>
    </a>
  );
};
